export const URL_PARAM_HIDE_ADMIN = "hide_admin"
export const URL_PARAM_POSTAL_CODE = "postcode"
export const URL_PARAM_QUOTE_ID = "quote_id"
